module.exports = __webpack_public_path__ + "static/media/Ficha-de-Sócio.8487ba83.docx";